<mat-sidenav-container fullscreen>
  <mat-sidenav #sidenav mode="over" class="side-menu" [opened]="opened">
    <button
      id="close"
      mat-icon-button
      (click)="toggleSidenav()"
      class="menu-button side-menu-close"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-nav-list (click)="goToHome()">
      <img
        class="nish-logo side-menu-logo"
        alt="nish-logo"
        src="./assets/images/nishtechlogo.png"
      />
    </mat-nav-list>
    <mat-nav-list>
      <app-menu
        *ngFor="let item of menus"
        [item]="item"
        (closeSide)="$event ? sidenav.toggle() : ''"
      ></app-menu>
    </mat-nav-list>
  </mat-sidenav>
  <mat-toolbar class="toolbar sticky">
    <div
      class="toolbar-left"
      style="display: flex; align-items: center; gap: 8px"
    >
      <button mat-icon-button (click)="toggleSidenav()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>
      <img
        class="nish-logo-toolbar"
        alt="nish-logo"
        src="/assets/images/nishtechlogo.png"
      />
    </div>
    <div class="toolbar-center">
      <h4 class="app-title">NConnect</h4>
    </div>
    <div class="toolbar-right">
      <button
        mat-button
        [matMenuTriggerFor]="menuI"
        class="user-button"
        style="
          font-size: 14px;
          color: white;
          margin: 0;
          display: flex;
          align-items: center;
        "
      >
        <img
          class="avatar"
          [src]="retrievedImage ? retrievedImage : '/assets/images/default.jpg'"
          (load)="imageLoading = false"
          (error)="onImageError($event)"
        />
        <span class="user-name">Hello,{{ shared.loggedUsername }}</span>
      </button>
      <mat-menu #menuI="matMenu">
        <p mat-menu-item>Role: {{ shared.userRole }}</p>
        <a mat-menu-item (click)="changePwd()" style="text-decoration: none"
          >Change Password</a
        >
        <a mat-menu-item (click)="logout()" style="text-decoration: none"
          >Logout</a
        >
      </mat-menu>
    </div>
  </mat-toolbar>
  <div class="">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
